import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';
export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'SoilAnalysis',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.EmployeeAndAgrifirm,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  API_BASE_URL: 'https://soil-analysis.agrifirm.com',
  AUTHORIZED_BY: {},
  APPLICATION_KEY: 'SoilAnalysis',
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: [IETFLocales.nl, IETFLocales.en],
  PRODUCTION: false,
  SHOP_URL: '',
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  RELATIONSHIPS_ELASTIC_SEARCH: false,
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: false,
  ERROR_PAGE_BACK_BUTTON: false,
  DELIVERY_TIME_WINDOW_DISABLED: false,
  SHOW_CART_ICON: false,
  SHOW_DISABLED_LOCATION_BADGE: false,
  SUBSCRIBE_TO_CART_EVENTS: false,
  IS_MY_PROSPECTS_HIDDEN: false,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: false,
}
